import { EGroupedItemsType } from '~/src/services/properties';
import { textCustomize } from './Part/textCustomizePartConfig';

export const textConfig = {
    label: {
        label: '',
        type: EGroupedItemsType.Title,
    },
    properties: {
        name: 'properties',
        items: {
            customize: textCustomize,
            content: {
                order: 0,
                label: 'Текст:',
                type: EGroupedItemsType.Text,
            },
            customStyles: {
                order: 2,
                label: 'Расширенные CSS-стили:',
                type: EGroupedItemsType.Text,
                withBreakpoints: true,
            },
        },
    },
};
